import { FC } from "react";
import { Box } from "@mui/material";
import GifSpinner from "../../assets/images/icons/spinner.gif";

interface Props {
  size?: number;
}

const LoadingSpinner: FC<Props> = ({ size = 120 }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={GifSpinner} alt="Loading..." width={size} height={size} />
    </Box>
  );
};

export default LoadingSpinner;
